import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { Delete, Refresh } from 'ui/icons';
import { LeftTooltip } from 'ui/tooltip';
import { useTranslations } from '../../../hooks/useTranslations';
import { LocaleActionMenuTooltipContent } from '../LocaleSwitcher.styled';

type LocaleActionMenuOptionsProps = {
  canDelete: boolean;
  isDisabled: boolean;
  canChangeDefault: boolean;
  isAssociatedWithActiveExperiment: boolean;
  hasSubmittedWhatsAppLocale: boolean;
  handleShowDeleteModal: (v: boolean) => void;
  handleShowDefaultLocaleModal: (v: boolean) => void;
};

export const useLocaleActionMenuOptions = ({
  handleShowDefaultLocaleModal,
  handleShowDeleteModal,
  canDelete,
  canChangeDefault,
  isDisabled,
  isAssociatedWithActiveExperiment = false,
  hasSubmittedWhatsAppLocale = false,
}: LocaleActionMenuOptionsProps): ActionMenuOption[] => {
  const { t } = useTranslations();

  const isOptionDisabled = isDisabled || isAssociatedWithActiveExperiment;

  const removeLocaleTooltipContent = isAssociatedWithActiveExperiment
    ? t('tooltip.experimentLocale')
    : t('tooltip.removeDefault');
  const isRemoveLocaleTooltipEnabled = !canDelete || isAssociatedWithActiveExperiment;

  const isChangeDefaultLocaleTooltipEnabled =
    isAssociatedWithActiveExperiment || hasSubmittedWhatsAppLocale;
  const changeDefaultTooltipContent = hasSubmittedWhatsAppLocale
    ? t('tooltip.whatsAppChangeDefaultLocale')
    : t('tooltip.experimentLocale');

  return [
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <LeftTooltip
          automaticallyAvoidCollisions
          tooltipContent={changeDefaultTooltipContent}
          isEnabled={isChangeDefaultLocaleTooltipEnabled}
        >
          <LocaleActionMenuTooltipContent isEnabled={isChangeDefaultLocaleTooltipEnabled}>
            <Refresh height={16} />
            <span>{t('button.changeDefault')}</span>
          </LocaleActionMenuTooltipContent>
        </LeftTooltip>
      ),
      id: 'btn-change-default',
      isDisabled: !canChangeDefault || isOptionDisabled || hasSubmittedWhatsAppLocale,
      onClick: () => handleShowDefaultLocaleModal(true),
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <LeftTooltip
          automaticallyAvoidCollisions
          tooltipContent={removeLocaleTooltipContent}
          isEnabled={isRemoveLocaleTooltipEnabled}
        >
          <LocaleActionMenuTooltipContent isEnabled={isRemoveLocaleTooltipEnabled}>
            <Delete height={16} />
            <span>{t('button.removeLocale')}</span>
          </LocaleActionMenuTooltipContent>
        </LeftTooltip>
      ),
      id: 'btn-remove-locale',
      isDisabled: !canDelete || isOptionDisabled,
      onClick: () => handleShowDeleteModal(true),
    },
  ];
};
